import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

type Props = {
	playbackId: string;
};

const VideoPlayer: React.FC<Props> = ({ playbackId }) => {
	const videoRef = useRef(null);

	useEffect(() => {
		const src = `https://stream.mux.com/${playbackId}.m3u8`;
		let hls: any;
		if (videoRef.current) {
			const video: any = videoRef.current;

			// Check hls.js first. Newer Chrome says "maybe" to canPlayType for HLS
			// but can't actually play Mux streams natively.
			if (Hls.isSupported()) {
				hls = new Hls();
				hls.loadSource(src);
				hls.attachMedia(video);
			} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
				// No MSE (older iOS Safari), use native HLS
				video.src = src;
			} else {
				console.error("This is a legacy browser that doesn't support MSE");
			}
		}

		return () => {
			if (hls) {
				hls.destroy();
			}
		};
	}, [videoRef, playbackId]);

	return (
		<video
			controls
			ref={videoRef}
			poster={`https://image.mux.com/${playbackId}/thumbnail.jpg`}
			style={{ width: '100%', maxWidth: '500px' }}
		/>
	);
};

export default VideoPlayer;
